import React, { useState, useEffect } from "react";
import { MenuItem, Select, TextField, Button, Box } from "@material-ui/core";
import useStyles from "../../../../styles";
import axios from "axios";
import { decryptData } from "../../../../crypto";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import TableView from "../../../CustomComponent/TableView";
import QuestionListHead from "./QuestionListHead";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import Loader from '../../../CustomComponent/Loader'

function AddMarks({ changeTab }) {
  const classes = useStyles();
  const { state } = useLocation();
  const total_score = state;
  const style = [
    {
      height: "h57vh",
      style: "viewtable",
      footer: true,
      pagination: false,
      checkboxselection: "true",
    },
  ];
  const { rowId } = useParams();
  const decryptedToken = decryptData(sessionStorage.getItem("token"));
  const navigate = useNavigate();

  const [questions, setQuestions] = useState([]);
  const [examName, setExamName] = useState("");
  const [loading, setLoading] = useState(false);

  const [anchorEl, setAnchorEl] = useState(null);
  const popoveropen = Boolean(anchorEl);
  const id = popoveropen ? "simple-popover" : undefined;

  let [Id, setId] = useState("");

  const handleCheckboxClick = (selectedIDs) => {
    setId(selectedIDs);
  };

  const fetchData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/question/mark/by_exam/${rowId}`,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        }
      );
      setQuestions(response.data.questions);
      console.log("questions12345", response.data.questions);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  // const fetchExamData = async () => {
  //   try {
  //     const response = await axios.get(
  //       `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/exam/${rowId}`,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${decryptedToken}`,
  //         },
  //       }
  //     );
  //     setExamName(response.data.exam.exam_name);
  //   } catch (error) {
  //     console.error("Error fetching exam data: ", error);
  //   }
  // };

  useEffect(() => {
    fetchData();
    // fetchExamData();
  }, [rowId]);

  const handleFieldChange = (id, field, value) => {
    setQuestions((prevQuestions) =>
      prevQuestions.map((question) =>
        question.id === id ? { ...question, [field]: value } : question
      )
    );
  };

  const handleSave = async () => {
    if (!Id || Id.length === 0) {
      toast.error("Please select at least one question.");
      return;
    }

    const data = Id.map((id) => ({
      question_id: id,
      exam_id: rowId,
      mode: "Recheck",
    }));

    setLoading(true);

    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/question/attempt/generalization`,
        data,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        }
      );

      toast.success("Generalization updated successfully!");
      fetchData(); // Refresh the data
      setLoading(false);
      setTimeout(() => {
        navigate("/admin/exam");
      }, 2000);
    } catch (error) {
      console.error("Error updating marks: ", error);
      toast.error(error.response.data.message);
      setLoading(false);
    }
  };

  const columns = [
    {
      field: "question_no",
      headerName: "Question No",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 120,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },

    {
      field: "subject",
      headerName: "Subject",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 120,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },

    {
      field: "question_type",
      headerName: "Question Type",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 200,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    // {
    //   field: "marks",
    //   headerName: "Marks",
    //   headerClassName: "super-app-theme--header",
    //   headerAlign: "center",
    //   width: 180,
    //   // flex: 1,
    //   sortable: false,
    //   disableColumnMenu: true,
    //   autoPageSize: false,
    //   renderCell: (cellValues) => {
    //     return (
    //       <div
    //         className={`${classes.dflex} ${classes.alignitemscenter} ${classes.justifycenter} ${classes.mr1}`}
    //       >
    //         <TextField
    //           onChange={(e) =>
    //             handleFieldChange(cellValues.row.id, "mark", e.target.value)
    //           }
    //           value={cellValues.row.mark || ""}
    //           type="number"
    //           variant="outlined"
    //           required
    //           placeholder="Enter Marks"
    //           onWheel={(e) => e.target.blur()}
    //         />
    //       </div>
    //     );
    //   },
    // },
    // {
    //   field: "partial_marks",
    //   headerName: "Partial Marks",
    //   headerClassName: "super-app-theme--header",
    //   headerAlign: "center",
    //   width: 180,
    //   // flex: 1,
    //   sortable: false,
    //   disableColumnMenu: true,
    //   autoPageSize: false,
    //   renderCell: (cellValues) => {
    //     return (
    //       <div
    //         className={`${classes.dflex} ${classes.alignitemscenter} ${classes.justifycenter} ${classes.mr1}`}
    //       >
    //         <TextField
    //           onChange={(e) =>
    //             handleFieldChange(
    //               cellValues.row.id,
    //               "partial_mark",
    //               e.target.value
    //             )
    //           }
    //           value={cellValues.row.partial_mark || ""}
    //           type="number"
    //           variant="outlined"
    //           required
    //           placeholder="Enter Partial Marks"
    //           disabled={cellValues.row.question_type !== "Multiple Choice"}
    //           onWheel={(e) => e.target.blur()}
    //         />
    //       </div>
    //     );
    //   },
    // },
    // {
    //   field: "negative_marking",
    //   headerName: "Negative Marking",
    //   headerClassName: "super-app-theme--header",
    //   headerAlign: "center",
    //   width: 180,
    //   // flex: 1,
    //   sortable: false,
    //   disableColumnMenu: true,
    //   autoPageSize: false,
    //   renderCell: (cellValues) => {
    //     return (
    //       <div
    //         className={`${classes.dflex} ${classes.alignitemscenter} ${classes.justifycenter} ${classes.mr1}`}
    //       >
    //         <Select
    //           labelId="negative-marking-label"
    //           style={{ width: "100px" }}
    //           id="negative_marking"
    //           value={cellValues.row.negative_marking || ""}
    //           onChange={(e) =>
    //             handleFieldChange(
    //               cellValues.row.id,
    //               "negative_marking",
    //               e.target.value
    //             )
    //           }
    //           displayEmpty
    //           className={classes.selectEmpty}
    //           variant="outlined"
    //         >
    //           <MenuItem disabled value="">
    //             Select Option
    //           </MenuItem>
    //           <MenuItem value="yes">Yes</MenuItem>
    //           <MenuItem value="no">No</MenuItem>
    //         </Select>
    //       </div>
    //     );
    //   },
    // },
    // {
    //   field: "negative_mark",
    //   headerName: "Negative Mark",
    //   headerClassName: "super-app-theme--header",
    //   headerAlign: "center",
    //   width: 180,
    //   // flex: 1,
    //   sortable: false,
    //   disableColumnMenu: true,
    //   autoPageSize: false,
    //   renderCell: (cellValues) => {
    //     return (
    //       <div
    //         className={`${classes.dflex} ${classes.alignitemscenter} ${classes.justifycenter} ${classes.mr1}`}
    //       >
    //         <TextField
    //           onChange={(e) => {
    //             let value = e.target.value;

    //             // Allow only digits (no dots, no negative signs)
    //             value = value.replace(/[^0-9.]/g, "");
    //             handleFieldChange(cellValues.row.id, "negative_mark", value);
    //           }}
    //           value={
    //             cellValues.row.negative_mark
    //               ? `-${String(cellValues.row.negative_mark).replace(
    //                   /^[-]+/,
    //                   ""
    //                 )}`
    //               : ""
    //           }
    //           type="text"
    //           variant="outlined"
    //           required
    //           placeholder="Enter Negative Mark"
    //           disabled={cellValues.row.negative_marking !== "yes"}
    //           onWheel={(e) => e.target.blur()}
    //         />
    //       </div>
    //     );
    //   },
    // },

    {
      field: "correct_answer",
      headerName: "Correct Answer", // Yeh hai aapka naya field
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 180,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      valueGetter: (params) => {
        // DataGrid version ke hisaab se row data 'row' ya 'data' me ho sakta hai
        const rowData = params.row || params.data;
        return rowData?.correct_answer || "";
      },
      renderCell: (cellValues) => {
        // Question Type fetch kar rahe hain
        const qType = cellValues.row.question_type
          ? cellValues.row.question_type.toLowerCase()
          : "";
        const value = questions.filter((q) => q.id === cellValues.row.id);
        return (
          <div
            className={`${classes.dflex} ${classes.alignitemscenter} ${classes.justifycenter} ${classes.mr1}`}
          >
            <TextField
              value={value[0].correct_answers || ""}
              variant="outlined"
              placeholder="Answer"
              disabled
              onChange={(e) => {
                let val = e.target.value;
                if (qType.includes("single")) {
                  if (val.length > 1) {
                    val = val.slice(0, 1).toUpperCase();
                  } else {
                    val = val.toUpperCase();
                  }
                } else if (
                  qType.includes("multiple") ||
                  qType.includes("choice")
                ) {
                  val = val
                    .split(",")
                    .map((item) => item.trim().split("")) // Split each item into characters
                    .flat() // Flatten the array
                    .join(",")
                    .toUpperCase();
                } else if (qType.includes("fill") || qType.includes("blank")) {
                  val = val.replace(/[^0-9]/g, "");
                }
                handleFieldChange(cellValues.row.id, "correct_answers", val);
              }}
            />
          </div>
        );
      },
    },
  ];

  const rows = questions.map((d, index) => ({
    id: d.id || "N/A",
    exam_id: d.exam_id || "N/A",
    question_no: d.q_prifix || "N/A",
    question_type: d.question_type || "N/A",
    mark: d.mark || "",
    correct_answer: d.correct_answer,
    subject: d?.subject?.subject_name || "N/A",
    partial_mark: d.partial_mark || "",
    negative_marking: d.negative_marking || "",
    negative_mark: d.negative_mark || "",
    active_status: d.active_status ? d.active_status : "N/A",
  }));

  return (
    <>
      <ToastContainer />

      {
        loading && <Loader loaderOpen={loading}/>
      }
      <div
        className={`${classes.mt1} ${classes.bgwhite} ${classes.inputpadding} ${classes.inputborder}`}
      >
        <QuestionListHead
          questionList={true}
          fetchData={fetchData}
          examName={examName}
        />

        <TableView
          columns={columns}
          rows={rows}
          Heading={style}
          onCheckboxClick={handleCheckboxClick}
        />

        <Box
          style={{
            display: "flex",
            justifyContent: "end",
            marginTop: "10px",
            gap: "10px",
          }}
        >
          <Button
            variant="outlined"
            onClick={() => navigate("/admin/exam")}
            className={classes.mr2}
          >
            Cancel
          </Button>
          <Button
            variant="outlined"
            onClick={handleSave}
            className={`${classes.custombtnblue}`}
          >
            {"Save Changes"}
          </Button>
        </Box>
      </div>
    </>
  );
}

export default AddMarks;
